{
  "login": {
    "title": "Anmelden",
    "subtitle": "Willkommen zurück",
    "username": "Benutzername",
    "password": "Passwort",
    "submit": "Anmelden",
    "submitting": "Anmelden…",
    "error": "Login fehlgeschlagen"
  },
  "profile": "Profil",
  "logout": "Abmelden"
}
